import React from 'react'
import PropTypes from 'prop-types'
import {
  ResponsiveContainer,
  ComposedChart,
  // Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
} from 'recharts'
import { Card } from 'react-bootstrap'

/**
 * AdExchangeChart
 * @param {Array<Object>} rawData – 直接放你從 Ad Manager 報表 API 取得的陣列
 * 範例結構見 README 或後端傳進來的 JSON
 */
function AdExchangeChart({ setting }) {
  const { data = [] } = setting

  return (
    <Card className="mb-4 shadow-sm">
      {/* <Card.Header>
        <strong>Ad Exchange Performance</strong>
      </Card.Header> */}
      <Card.Body>
        {/* Filters */}

        {/* Chart */}
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis
              yAxisId="left"
              label={{
                value: 'Impressions',
                angle: -90,
                position: 'insideLeft',
              }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: 'Revenue', angle: 90, position: 'insideRight' }}
            />
            <Tooltip formatter={(value) => value.toLocaleString()} />
            <Legend />
            {/* <Bar
              yAxisId="left"
              dataKey="impressions"
              name="Impressions"
              barSize={12}
            /> */}
            <Line
              yAxisId="left"
              type="linear"
              dataKey="impressions"
              name="Impressions"
              strokeWidth={2}
              dot={false}
            />
            <Line
              yAxisId="right"
              type="linear"
              dataKey="revenue"
              name="Revenue"
              stroke="red"
              strokeWidth={2}
              dot={false}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  )
}

AdExchangeChart.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default AdExchangeChart
